"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.makeSearchQuery = makeSearchQuery;
exports.makeSearchResponse = makeSearchResponse;
exports.makeSearchResolver = void 0;

var _get = _interopRequireDefault(require("transmute/get"));

var _immutable = require("immutable");

var _ReferenceRecord = _interopRequireDefault(require("../schema/ReferenceRecord"));

var _Strategy = require("./Strategy");

var _enforce = require("reference-resolvers/lib/enforce");

var _ResolverLoading = _interopRequireDefault(require("reference-resolvers/schema/ResolverLoading"));

var _ResolverError = _interopRequireDefault(require("reference-resolvers/schema/ResolverError"));

var getCount = (0, _get.default)('count');
var getHasMore = (0, _get.default)('hasMore');
var getOffset = (0, _get.default)('offset');
var getQuery = (0, _get.default)('query');
var getResults = (0, _get.default)('results');

function _makeIterable(value) {
  if (!_immutable.Iterable.isIterable(value)) {
    return (0, _immutable.fromJS)(value);
  }

  return value;
}

function makeSearchQuery(key) {
  (0, _enforce.enforceIterable)('key', key);
  (0, _enforce.enforcePositiveInt)('count', getCount(key));
  (0, _enforce.enforcePositiveInt)('offset', getOffset(key));
  (0, _enforce.enforceString)('query', getQuery(key));
  return _makeIterable(key);
}

function makeSearchResponse(response) {
  if (response instanceof _ResolverError.default || response instanceof _ResolverLoading.default) {
    return response;
  }

  (0, _enforce.enforceIterable)('response', response);
  (0, _enforce.enforcePositiveInt)('count', getCount(response));
  (0, _enforce.enforceBoolean)('hasMore', getHasMore(response));
  (0, _enforce.enforcePositiveInt)('offset', getOffset(response));

  _ReferenceRecord.default.enforceReferenceIterable(getResults(response));

  return _makeIterable(response);
}

var makeSearchResolver = (0, _Strategy.makeKeyedResolver)({
  idTransform: makeSearchQuery,
  valueTransform: makeSearchResponse
});
exports.makeSearchResolver = makeSearchResolver;